export default "__VITE_ASSET__DuxcSK2E__"